<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'export-offers'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb>
  <div style="margin-top: 30px;">
    <app-verify-pallets-component [isClosedSale]="true" [dto]="importOrderDetailInformationDto" [directSaleProgramId]="directSaleProgramId"  *ngIf="importOrderDetailInformationDto" (updatePalletEvent)="updateView()" ></app-verify-pallets-component>
  </div>
</app-user-dashboard>

